import { post, get } from "@/plugin/newAxios";

// 个人客户修改
export const updateUserAuthApi = params => post("/khfw/v1/userInfo/updateUserAuth", params)

// 省查询接口
export const provinceInfoQryApi = params => post("/khfw/v1/area/provinceInfoQry", params)

// 查询单条记录
export const queryUserAuthApi = userId => get("/khfw/v1/userInfo/queryUserAuth/" + userId)

// 更改手机号
export const AreaInfoQryApi = params => post("/khfw/v1/area/AreaInfoQry", params)

// 上传图片接口
export const uploadUrlApi = params => post("/khfw/v1/userInfo/uploadUrl", params)

// 国籍下拉列表
export const countryListApi = params => post("/common/v1/country/list", params)

//注销
export const userzx = params => post("/khfw/v1/user/zxLogin", params)

//获取最新的对外app
export const getdwapp = params => post("/zhfw/v1/outApp/select", params)